<script>
  import LoadingEllipsis from "$lib/UI/LoadingEllipsis.svelte";
  export let message = "";
</script>

<div class="backdrop">
  <LoadingEllipsis />
  <div class="message">{message}</div>
</div>

<style>
  .message {
    font-size: larger;
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.25);
    z-index: 200;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
